import { CommandListMyActions } from "./commands/cmdListMyActions";
import { CommandListMyTodos } from "./commands/cmdListMyTodos";
import { CommandApproveAction } from "./commands/cmdApproveAction";
import { CommandRequestChangesAction } from "./commands/cmdRequestChangesAction";
import { CommandGetActionReview } from "./commands/cmdGetActionReview";

export class MyTodosService {
  async listActions(userId: number) {
    return new CommandListMyActions().run(userId);
  }

  async listTodos(userId: number) {
    return new CommandListMyTodos().run(userId);
  }

  async approve(engagementId: number, actionId: number) {
    return new CommandApproveAction().run(engagementId, actionId);
  }

  async requestChanges(engagementId: number, actionId: number) {
    return new CommandRequestChangesAction().run(engagementId, actionId);
  }

  async getActionReview(actionId: number) {
    return new CommandGetActionReview().run(actionId);
  }
}
